module.exports = __webpack_public_path__ + "static/media/flight.5fe34c6d.svg";